import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AnnouncementBar from "./AnnouncementBar";
import Navigation from "./Navigation";
import Footer from "./Footer";
import LoadingScreen from "./LoadingScreen";
import CustomCursor from "./CustomCursor";
import CartDrawer from "./CartDrawer";

export const Layout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <LoadingScreen />
      <CustomCursor />
      <AnnouncementBar />
      <Navigation />
      <CartDrawer />
      <main
        key={location.pathname}
        className="wc-page-enter relative z-[1] min-h-screen"
        data-testid="page-main"
      >
        {children}
      </main>
      <Footer />
    </>
  );
};

export default Layout;
